module.exports = ".row {\r\n    padding: 20px;\r\n}\r\n\r\n.row:nth-child(odd) {\r\n    /* background: #f3f3f3; */\r\n}\r\n\r\n@media print {\r\n    .text-center {\r\n    display: none;\r\n    }\r\n   }"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/emp-payslip/emp-payslip.component.css
// module id = ./src/app/hrms/emp-payslip/emp-payslip.component.css
// module chunks = main